/**
 * Notifications API client — typed functions for the in-app notification endpoints.
 */
import { apiClient } from './index';

export interface Notification {
  id: string;
  tenant_id: string;
  user_id: string;
  type: string; // task_assigned | comment_added | milestone_due | project_added
  title: string;
  body: string;
  entity_type: string;
  entity_id: string;
  route: string;
  read_at: string | null;
  created_at: string;
}

export interface NotificationsResponse {
  data: Notification[];
  unread_count: number;
}

export async function getNotifications(
  onlyUnread = false,
  limit = 30,
): Promise<NotificationsResponse> {
  const { data } = await apiClient.get<NotificationsResponse>('/notifications', {
    params: { unread: onlyUnread ? 'true' : undefined, limit: String(limit) },
  });
  return data;
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await apiClient.get<{ unread_count: number }>('/notifications/unread-count');
  return data.unread_count;
}

export async function markRead(id: string): Promise<void> {
  await apiClient.patch(`/notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await apiClient.patch('/notifications/read-all');
}
